import {
  hexToRGB,
  MOON_250,
  MOON_500,
  TEAL_500,
} from '@wandb/weave/common/css/globals.styles';
import styled from 'styled-components';

export const TextArea = styled.textarea`
  border: 1px solid ${MOON_250};
  border-radius: 4px;
  padding: 8px 12px;
  width: 100%;
  font-family: 'Source Sans Pro';
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  resize: none;

  &:focus-visible {
    border: 1px solid transparent;
    outline: 2px solid ${MOON_250};
  }

  &:hover {
    border: 1px solid transparent;
    outline: 2px solid ${hexToRGB(TEAL_500, 0.4)};
  }

  &::placeholder {
    color: ${MOON_500};
  }
`;
TextArea.displayName = 'S.TextArea';
